import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, CheckCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-slate-900 py-20 px-4" data-id="element-139">
      <div className="max-w-5xl mx-auto" data-id="element-140">
        <motion.h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-16" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-141">
          Por qué las{' '}
          <span className="text-red-400" data-id="element-142">soluciones viejas fallan</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-143">
          {/* Old Way */}
          <motion.div className="bg-slate-800 border-2 border-red-500/30 rounded-xl p-8" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-144">
            <div className="flex items-center gap-3 mb-6" data-id="element-145">
              <XCircleIcon className="w-8 h-8 text-red-400" data-id="element-146" />
              <h3 className="font-heading text-2xl font-bold text-red-400" data-id="element-147">
                La Forma Antigua
              </h3>
            </div>
            <ul className="space-y-4 text-gray-300" data-id="element-148">
              <li className="flex items-start gap-3" data-id="element-149">
                <span className="text-red-400 mt-1" data-id="element-150">✗</span>
                <span data-id="element-151">Cursos de 6 meses que nunca terminas</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-152">
                <span className="text-red-400 mt-1" data-id="element-153">✗</span>
                <span data-id="element-154">Aprender a hacer "prompts de relleno"</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-155">
                <span className="text-red-400 mt-1" data-id="element-156">✗</span>
                <span data-id="element-157">Saber hacer un poema con ChatGPT</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-158">
                <span className="text-red-400 mt-1" data-id="element-159">✗</span>
                <span className="font-semibold" data-id="element-160">
                  Resultado: No paga la renta
                </span>
              </li>
            </ul>
          </motion.div>

          {/* New Way */}
          <motion.div className="bg-gradient-to-br from-teal-900/40 to-gold-900/40 border-2 border-gold-400/50 rounded-xl p-8" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-161">
            <div className="flex items-center gap-3 mb-6" data-id="element-162">
              <CheckCircleIcon className="w-8 h-8 text-gold-400" data-id="element-163" />
              <h3 className="font-heading text-2xl font-bold text-gold-400" data-id="element-164">
                La Nueva Forma
              </h3>
            </div>
            <ul className="space-y-4 text-gray-200" data-id="element-165">
              <li className="flex items-start gap-3" data-id="element-166">
                <span className="text-gold-400 mt-1" data-id="element-167">✓</span>
                <span data-id="element-168">Ejecución en 48 horas</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-169">
                <span className="text-gold-400 mt-1" data-id="element-170">✓</span>
                <span data-id="element-171">Instalar agentes de ventas que trabajan 24/7</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-172">
                <span className="text-gold-400 mt-1" data-id="element-173">✓</span>
                <span data-id="element-174">Resolver problemas reales de negocios</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-175">
                <span className="text-gold-400 mt-1 font-bold" data-id="element-176">✓</span>
                <span className="font-semibold text-gold-400" data-id="element-177">
                  Resultado: Sí paga la renta
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}